import { render, staticRenderFns } from "./RegisterModuleBasic.vue?vue&type=template&id=4262f4c8&scoped=true&"
import script from "./RegisterModuleBasic.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleBasic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModuleBasic.vue?vue&type=style&index=0&id=4262f4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262f4c8",
  null
  
)

export default component.exports